var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Viewport',[_c('div',{staticClass:"Section"},[_c('div',{staticClass:"Section__rotate sections"},[_c('div',{staticClass:"Section__text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }